import { Grid, Hidden } from '@mui/material'

/**
 * Renders the header for the Pauta (checklist) items table.
 *
 * @param {object} props - The component props.
 * @param {object} props.report - The report object, used to determine 'reportType'.
 */
const PautaItemHeader = ({ report }) => {
    return (
        <Grid container>
            <Grid item xs={'auto'}>
                <p style={{ fontSize: 12, margin: 0, textAlign: 'center', width: 30 }}> <strong>N°</strong> </p>
            </Grid>
            <Grid item sm={1}>
                <p style={{ fontSize: 12, margin: 0, textAlign: 'center', width: '100%' }}> <strong>Personal <br /> Necesario</strong> </p>
            </Grid>
            <Grid item sm={'auto'}>
                <div style={{ width: 150 }}>
                    <p style={{ fontSize: 12, margin: 0, textAlign: 'center' }}> <strong>Descripcion De Tarea</strong> </p>
                </div>
            </Grid>
            <Grid item sm={3} md={2}>
                <p style={{ fontSize: 12, margin: 0, textAlign: 'center' }}> <strong>Observaciones</strong> </p>
            </Grid>
            <Hidden mdDown>
                {(report.reportType === 'Mantención') && <Grid item xl={'auto'} md={'auto'}>
                    <p style={{ fontSize: 12, margin: 0, textAlign: 'center', width: 100 }}> <strong>N° Parte <br /> a Utilizar</strong> </p>
                </Grid>}
                {(report.reportType === 'Mantención') && <Grid item xl={'auto'} md={'auto'}>
                    <p style={{ fontSize: 12, margin: 0, textAlign: 'center', width: 100 }}> <strong>Cantidad <br /> a utilizar</strong> </p>
                </Grid>}
                {(report.reportType === 'Mantención') && <Grid item xl={'auto'} md={'auto'}>
                    <p style={{ fontSize: 12, margin: 0, textAlign: 'center', width: 60 }}> <strong>Cantidad <br /> Utilizada</strong> </p>
                </Grid>}
                {(report.reportType === 'Mantención') && <Grid item xl={'auto'} md={'auto'}>
                    <p style={{ fontSize: 12, margin: 0, textAlign: 'center', width: 60 }}> <strong>Tipo <br /> Rpto</strong> </p>
                </Grid>}
                {(report.reportType === 'Mantención') && <Grid item xl={'auto'} md={'auto'}>
                    <p style={{ fontSize: 12, margin: 0, textAlign: 'center', width: 100 }}> <strong>Parámetro <br /> a Medir</strong> </p>
                </Grid>}
                {(report.reportType === 'Mantención') && <Grid item xl={'auto'} md={'auto'}>
                    <p style={{ fontSize: 12, margin: 0, textAlign: 'center', width: 60 }}> <strong>Parámetro <br /> Obtenido</strong> </p>
                </Grid>}
            </Hidden>
            <Grid item sm={1}>
                <p style={{ fontSize: 12, margin: 0, marginLeft: 5, textAlign: 'left' }}> <strong>Acción</strong> </p>
            </Grid>
            <Grid item sm={1}>
                <p style={{ fontSize: 12, margin: 0, marginLeft: 5, textAlign: 'left' }}> <strong>Estado</strong> </p>
            </Grid>
        </Grid>
    )
}

export default PautaItemHeader
